import React, { useState } from "react";
import emailjs from "emailjs-com";
import HeaderInner from '../header/HeaderInner';
import Contact from '../inner/breadcrumb/Contact';
import Footer from '../elements/Footer';
import Swal from "sweetalert2"; // ✅ Install: npm install sweetalert2





function ContactPage() {
    const [formData, setFormData] = useState({
        name: "",
        phone: "",
        email: "",
        subject: "",
        message: "",
    });

    const handleChange = (e) => {
        setFormData({
            ...formData,
            [e.target.name]: e.target.value,
        });
    };

   const handleSubmit = (e) => {
        e.preventDefault();

        emailjs
            .send(
                "service_da6352w", // Service ID
                "template_wrcgsio", // Template ID
                formData,
                "hkCOv4iqj-SELjBbr" // Public key
            )
            .then(
                (response) => {
                    console.log("SUCCESS!", response.status, response.text);

                    Swal.fire({
                        icon: "success",
                        title: "Message Sent!",
                        text: "Your message has been sent successfully. We will get back to you shortly.",
                        confirmButtonColor: "#3085d6",
                        confirmButtonText: "OK"
                    });

                    setFormData({
                        name: "",
                        phone: "",
                        email: "",
                        subject: "",
                        message: "",
                    });
                },
                (err) => {
                    console.error("FAILED...", err);

                    Swal.fire({
                        icon: "error",
                        title: "Oops!",
                        text: "Failed to send message. Please try again later.",
                        confirmButtonColor: "#d33",
                        confirmButtonText: "Close"
                    });
                }
            );
    };


    return (
        <div className='service-details contact-page'>
            <div className="">
                <HeaderInner />
                <main>
                    <Contact />
                    {/* tmp contact area */}
                    <div className="contact-area tmp-section-gap">
                        <div className="container">
                            <div className="row g-5">
                                <div className="col-lg-5">
                                    <div className="contact-inner">
                                        <div className="section-head section-head-one-side text-align-left">
                                            <span className="title">Contact Us</span>
                                            {/* <p className="description">
                                                Get expert audit, VAT, and ERP advice tailored to your business needs and compliance goals.
                                            </p> */}
                                        </div>
                                        <ul className="ft-link ft-link-style-three">
                                            <li>
                                                <div className="single-contact background-transparent">
                                                    <div className="icon">
                                                        <i className="fa-light fa-phone" />
                                                    </div>
                                                    <div className="content">
                                                        <span>Call Us</span>
                                                        <a className="contact-here" href="tel:+4733378901">
                                                            +973 17552393 
                                                        </a>
                                                    </div>
                                                </div>
                                            </li>
                                            <li>
                                                <div className="single-contact background-transparent">
                                                    <div className="icon">
                                                        <i className="fa-solid fa-envelope-open-text" />
                                                    </div>
                                                    <div className="content">
                                                        <span>E-mail</span>
                                                        <a
                                                            className="contact-here"
                                                            href="mailto:info@aqauditing.com "
                                                        >
                                                             info@aqauditing.com 
                                                        </a>
                                                    </div>
                                                </div>
                                            </li>
                                            <li>
                                                <div className="single-contact background-transparent">
                                                    <div className="icon">
                                                        <i className="fa-regular fa-map-location-dot" />
                                                    </div>
                                                    <div className="content">
                                                        <span>Address</span>
                                                        <a className="contact-here" href="#">
                                                            Office 109, Building 628
                                                            Road 1011, Block 410
                                                            Sanabis, Manama
                                                            P.O. Box 18569
                                                            Kingdom of Bahrain
                                                        </a>
                                                    </div>
                                                </div>
                                            </li>
                                        </ul>
                                        {/* <div className="tmp-tag-list tag-list-one">
                                            <a className="tag-list" href="#">
                                                Facebook
                                            </a>
                                            <a className="tag-list" href="#">
                                                Twitter
                                            </a>
                                            <a className="tag-list" href="#">
                                                Linkedin
                                            </a>
                                            <a className="tag-list" href="#">
                                                Skype
                                            </a>
                                            <a className="tag-list" href="#">
                                                Pinterest
                                            </a>
                                        </div> */}
                                    </div>
                                </div>
                                <div className="col-lg-7">
                                    <div className="contact-inner">
                                        <div className="section-head section-head-one-side text-align-left">
                                            <span className="title">GET IN TOUCH</span>
                                            <p className="description">
                                                Reach out to AQ Audit for professional support in finance, strategy, and regulatory services.
                                            </p>
                                        </div>
                                        <div className="contact-form style-two">
                                            <div id="form-messages" />
                                            <form id="contact-form" onSubmit={handleSubmit}>
                                                <div className="contact-form-wrapper row">
                                                    <div className="col-lg-6">
                                                        <div className="form-group">
                                                            <input
                                                                className="input-field"
                                                                name="name"
                                                                placeholder="Name"
                                                                id="contact-name"
                                                                type="text"
                                                                value={formData.name}
                                                                onChange={handleChange}
                                                                required
                                                            />
                                                        </div>
                                                    </div>
                                                    <div className="col-lg-6">
                                                        <div className="form-group">
                                                            <input
                                                                className="input-field"
                                                                name="phone"
                                                                placeholder="Phone"
                                                                type="text"
                                                                value={formData.phone}
                                                                onChange={handleChange}
                                                                required
                                                            />
                                                        </div>
                                                    </div>
                                                    <div className="col-lg-6">
                                                        <div className="form-group">
                                                            <input
                                                                className="input-field"
                                                                name="email"
                                                                placeholder="Email"
                                                                type="email"
                                                                value={formData.email}
                                                                onChange={handleChange}
                                                                required
                                                            />
                                                        </div>
                                                    </div>
                                                    <div className="col-lg-6">
                                                        <div className="form-group">
                                                            <input
                                                                className="input-field"
                                                                name="subject"
                                                                placeholder="Subject"
                                                                type="text"
                                                                value={formData.subject}
                                                                onChange={handleChange}
                                                                required
                                                            />
                                                        </div>
                                                    </div>
                                                    <div className="col-lg-12">
                                                        <div className="form-group">
                                                            <textarea
                                                                className="input-field"
                                                                name="message"
                                                                placeholder="How can we help"
                                                                value={formData.message}
                                                                onChange={handleChange}
                                                                required
                                                                id="contact-message"
                                                            />
                                                        </div>
                                                    </div>
                                                    <div className="col-lg-12">
                                                        <div className="form-submit-group">
                                                            <button className="tmp-btn btn-primary" type="submit">
                                                                Submit Now
                                                            </button>
                                                        </div>
                                                    </div>
                                                </div>
                                            </form>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    {/* tmp contact area */}
                    <div className="tmp-map-area tmp-sectiongapBottom">
                        <div className="map-area-flotimg-container">
                            <iframe
                                src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d7210.257460610342!2d50.5474413!3d26.2335844!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3e49a7d432fa60f7%3A0xb31f3de4638d7298!2sSanabis%2C%20Bahrain!5e0!3m2!1sen!2sin!4v1659876543210!5m2!1sen!2sin"
                                width={600}
                                height={650}
                                style={{ border: 0 }}
                                allowFullScreen=""
                                loading="lazy"
                                referrerPolicy="no-referrer-when-downgrade"
                            />
                        </div>
                    </div>
                    <Footer />
                </main>
            </div>
        </div>
    )
}

export default ContactPage